/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { Component, HostBinding, inject, ChangeDetectionStrategy, output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from '@openng/optimus-ui/inputtext';

import {
  NumberInputFormControlDirective,
  NumberInputFormControlDirectiveInputs,
} from '../directives/number-input-form-control.directive';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { InputComponent } from './input.component';

@Component({
  selector: 'ui-number-input',
  templateUrl: './number-input.component.html',
  imports: [ReactiveFormsModule, InputWrapperComponent, InputTextModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NumberInputComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [
    {
      directive: NumberInputFormControlDirective,
      inputs: NumberInputFormControlDirectiveInputs,
    },
  ],
})
export class NumberInputComponent extends InputComponent {
  readonly valueChange = output<number>();

  @HostBinding('class.has-controls-hidden')
  get controlsHiddenClass() {
    return this.number.hideControls();
  }

  number = inject(NumberInputFormControlDirective);

  emitNumberValueChange(evt: string) {
    this.valueChange.emit(Number(evt));
  }

  /** Z klávesnice jen číslice; ovládací klávesy (Enter, Backspace, šipky …) mají `key` delší než jeden znak. */
  validateNumber(e: KeyboardEvent): boolean {
    return e.key.length > 1 || /^\d$/.test(e.key);
  }

  trimValuePaste(e: ClipboardEvent) {
    e.stopPropagation();
    e.preventDefault();

    // Get pasted data via clipboard API
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clipboardData = e.clipboardData || (window as any).clipboardData;
    const pastedData = (clipboardData?.getData('Text') ?? '').trim();

    // Přijmout jen celá čísla – stejné omezení jako vstup z klávesnice (validateNumber blokuje '.' i '-').
    if (/^\d+$/.test(pastedData)) {
      this.control.patchValue(pastedData);
    }
  }
}
